/**
 * @module 警備操作部共通コンポーネント
 */
export default {
  name: 'News',
  data(vm) {
    return {
      items: ['対象地区 - 自宅', '対象地区 - 会社', '対象地区 - その他'],
      lists: [
        {
          id: 1,
          name: vm.$vuetify.lang.t('$vuetify.FECU07.外出'), //"外出",
          value: vm.$vuetify.lang.t('$vuetify.FECU07.外出'), // "外出",
          color: 'indigo',
        },
        {
          id: 2,
          name: vm.$vuetify.lang.t('$vuetify.FECU07.在宅'), //"在宅",
          value: vm.$vuetify.lang.t('$vuetify.FECU07.在宅'), //"在宅",
          color: 'indigo',
        },
        {
          id: 3,
          name: vm.$vuetify.lang.t('$vuetify.FECU07.解除'), //"解除",
          value: vm.$vuetify.lang.t('$vuetify.FECU07.解除'), //"解除",
          color: 'indigo',
        },
        {
          id: 4,
          name: vm.$vuetify.lang.t('$vuetify.FECU07.オンライン'), //"オンライン",
          value: vm.$vuetify.lang.t('$vuetify.FECU07.オンライン'), // "オンライン",
          color: 'indigo',
        },
        {
          id: 5,
          name: vm.$vuetify.lang.t('$vuetify.FECU07.セルフ'), //"セルフ",
          value: vm.$vuetify.lang.t('$vuetify.FECU07.セルフ'), //"セルフ",
          color: 'indigo',
        },
      ],
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        lists: [
          {
            id: 1,
            name: vm.$vuetify.lang.t('$vuetify.FECU07.外出'), //"外出",
            value: vm.$vuetify.lang.t('$vuetify.FECU07.外出'), // "外出",
            color: 'indigo',
          },
          {
            id: 2,
            name: vm.$vuetify.lang.t('$vuetify.FECU07.在宅'), //"在宅",
            value: vm.$vuetify.lang.t('$vuetify.FECU07.在宅'), //"在宅",
            color: 'indigo',
          },
          {
            id: 3,
            name: vm.$vuetify.lang.t('$vuetify.FECU07.解除'), //"解除",
            value: vm.$vuetify.lang.t('$vuetify.FECU07.解除'), //"解除",
            color: 'indigo',
          },
          {
            id: 4,
            name: vm.$vuetify.lang.t('$vuetify.FECU07.オンライン'), //"オンライン",
            value: vm.$vuetify.lang.t('$vuetify.FECU07.オンライン'), // "オンライン",
            color: 'indigo',
          },
          {
            id: 5,
            name: vm.$vuetify.lang.t('$vuetify.FECU07.セルフ'), //"セルフ",
            value: vm.$vuetify.lang.t('$vuetify.FECU07.セルフ'), //"セルフ",
            color: 'indigo',
          },
        ],
      };
    },
  },
};
